import {
  Body,
  Button,
  Card,
  Col,
  LazyImage,
  Row,
  ThemeProps,
  styled,
} from '@teko/ds-desktop';
import {
  BuildPcNumberStepper,
  ProductGifts,
  ProductName,
  ProductPrice,
} from '@teko/ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { t } from 'i18n';
import React, { ReactNode } from 'react';

const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
export interface BuildPcMobileItemProps {
  title?: string;
  product?: ProductCardProps;
  icon?: string;
  onClick?: () => void;
  onIncrease?: () => void;
  onDecrease?: () => void;
  setQuantity?: (value: number) => void;
  actionText: string | ReactNode;
  quantity?: number;
  showDeleteButton?: boolean;
  onDelete?: () => void;
}
const StyledCard = styled(Card)`
  padding: 1rem;
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);
  }
`;
const StyledPrice = styled(ProductPrice)`
  min-height: auto;
`;
const Title = styled.div`
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
`;
const StyledProductGifts = styled(ProductGifts)`
  margin-top: 5px;
`;
const SKU = styled.span`
  color: #757575;
  font-size: 0.8125rem;
`;
const StyledButton = styled(Button)`
  height: 32px;
  width: 60px;
  padding: 0;
`;
const StyledButtonDelete = styled(Body)(
  ({ theme }: ThemeProps) => `
  color: ${theme?.colors.link500};
`,
);

export const BuildPcMobileItem: React.FC<BuildPcMobileItemProps> = ({
  title,
  product,
  onIncrease,
  onDecrease,
  onClick,
  actionText,
  quantity,
  setQuantity,
  showDeleteButton,
  onDelete,
  ...props
}: BuildPcMobileItemProps) => {
  const disableButton = () => {
    if (product && !product?.price?.latestPrice) return true;
  };

  const selectHardwareButton =
    product && product.showContact ? (
      <StyledButton
        block
        variant="primary"
        onClick={() => {
          const newWindow = window.open(
            'https://m.me/phongvuvietnam',
            '_blank',
            'noopener,noreferrer',
          );
          if (newWindow) {
            newWindow.opener = null;
          }
        }}
      >
        {t('Liên hệ')}
      </StyledButton>
    ) : (
      <StyledButton
        disabled={disableButton()}
        onClick={onClick}
        variant="primary"
      >
        {actionText}
      </StyledButton>
    );

  return (
    <StyledCard {...props}>
      <Row align="middle">
        {title && (
          <>
            <Col span={4}>
              <Row justify="start" marginBottom={product ? 's16' : undefined}>
                <Title>{title}</Title>
              </Row>
            </Col>
            {!product && (
              <Col span={8}>
                <Row justify="end">{selectHardwareButton}</Row>
              </Col>
            )}
          </>
        )}
      </Row>
      <Row>
        {product && (
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: 10,
            }}
          >
            <Row>
              <LazyImage
                width={65}
                height={65}
                src={product?.imageUrl}
                onClick={(): void => {
                  if (!product) onClick?.();
                }}
                border
                borderRadius={8}
                contain
              />
            </Row>
            {/*TODO: fix type of Anchor href*/}
            <Row style={{ flex: 1 }}>
              <Col span={12}>
                <Anchor
                  // @ts-ignore
                  href={product.link?.as?.pathname}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <ProductName
                    name={product.name || t('Tên sản phẩm đang được cập nhật')}
                  />
                </Anchor>

                <Row marginTop="s4">
                  <SKU>SKU: {product.sku}</SKU>
                </Row>
                {product.gifts && (
                  <Row>
                    <StyledProductGifts
                      label={t('Tặng ngay')}
                      images={product.gifts.images}
                    />
                  </Row>
                )}
                {product.price && (
                  <Row marginTop="s8">
                    <StyledPrice
                      {...{
                        price: product.price.latestPrice,
                        discount: product.price.discountPercent,
                        listedPrice: product.price.supplierRetailPrice,
                      }}
                    />
                  </Row>
                )}
                {quantity && (
                  <Row marginTop="s8" align="middle" justify="start">
                    <Col style={{ display: 'flex', flexDirection: 'column' }}>
                      <Row>
                        <BuildPcNumberStepper
                          onIncrease={onIncrease}
                          onDecrease={onDecrease}
                          setValue={setQuantity}
                          value={quantity}
                        />
                      </Row>
                      {showDeleteButton && (
                        <Row justify="center" align="middle" marginTop="s12">
                          <StyledButtonDelete level={1} onClick={onDelete}>
                            {t('Xóa')}
                          </StyledButtonDelete>
                        </Row>
                      )}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
            <Row justify="start">{selectHardwareButton}</Row>
          </Col>
        )}
      </Row>
    </StyledCard>
  );
};
